module.exports = __webpack_public_path__ + "img/copy-catter.f2bb407d.png";